import React, { Component } from 'react';
import './MenuItem.css';
import { Link } from 'react-router-dom';

class MenuItem extends Component {
  constructor(props) {
    super(props);

    this.state = { searching: false };

    // This binding is necessary to make `this` work in the callback
    this.handleClick = this.handleClick.bind(this);
    this.handleRevealSearch = this.handleRevealSearch.bind(this);
    this.handleCloseSearch = this.handleCloseSearch.bind(this);
  }

  handleRevealSearch() {
    this.setState({ searching: true });
  }

  handleCloseSearch() {
    this.setState({ searching: false });
  }

  handleClick() {
    this.props.info.callback.showElement(this.props.info.label);
  }

  render() {
    let result = {};

    if (this.props.info.type === 'anchor') {
      result = (
        <a
          className={this.state.searching ? 'MenuItem searching' : 'MenuItem'}
          href={this.props.info.path}
          target="_blank"
          rel="noopener noreferrer"
        >
          {this.props.info.label}
        </a>
      );
    } else {
      result = (
        <Link
          className={this.state.searching ? 'MenuItem searching' : 'MenuItem'}
          to={this.props.info.path}
          title={this.props.info.title}
        >
          {this.props.info.label}
        </Link>
      );
    }
    return result;
  }
}

export default MenuItem;
